// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_outer_big {
  background: rgba(51, 65, 85, 0.1);
  border-radius: 7px;
  text-align: center;
  width: 100%;
  display: inline-block;
  transition: 0.2s;
  position: relative;
  padding: 10px;
  border: 2px dotted rgba(51, 65, 85, 0.3);
  overflow: hidden;
  margin-bottom: 30px;
}
.img-responsive {
  display: block;
  max-width: 100%;
  width: 100%;
}
/*# sourceMappingURL=upload.component.css.map */`, "",{"version":3,"sources":["webpack://./upload.component.less","webpack://./src/app/components/upload/upload.component.less"],"names":[],"mappings":"AAEA;EACE,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;ACDF;ADIA;EACE,cAAA;EACA,eAAA;EACA,WAAA;ACFF;AACA,+CAA+C","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n.button_outer_big {\n  background: fade(@ness_color_2, 10%);\n  border-radius: @radius;\n  text-align: center;\n  width: 100%;\n  display: inline-block;\n  transition: 0.2s;\n  position: relative;\n  padding: 10px;\n  border: 2px dotted fade(@ness_color_2, 30%);\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  width: 100%;\n}\n\n",".button_outer_big {\n  background: rgba(51, 65, 85, 0.1);\n  border-radius: 7px;\n  text-align: center;\n  width: 100%;\n  display: inline-block;\n  transition: 0.2s;\n  position: relative;\n  padding: 10px;\n  border: 2px dotted rgba(51, 65, 85, 0.3);\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n.img-responsive {\n  display: block;\n  max-width: 100%;\n  width: 100%;\n}\n/*# sourceMappingURL=upload.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
